var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "struct_rule" } }, [
      _c("div", { attrs: { id: "container" } }, [
        _c("div", { attrs: { id: "content" } }, [
          _c("div", { staticClass: "title" }, [
            _c("h2", [_vm._v("組立・設置サービスにおける注意事項・免責事項")])
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "terms_sec" }, [
            _c("ul", [
              _c("li", [
                _vm._v(
                  "・商品到着後速やかに商品に破損、不良又は不足等がないかを確認してください。"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "・組立・設置の作業スペースの確保が難しい場合には予め当社に連絡してください。"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "・床・壁・天井の材質により固定できない場合(漆喰やベニヤ等)や十分な耐荷重を"
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "indent" }, [
                _vm._v("得られない場合は、契約キャンセルとなります。")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "indent" }, [
                _vm._v(
                  "その場合でも家具はお買取りいただき、組立技術料はご請求させていただきます。"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "・実際の組立技術料が現場状況などにより、当初の見積料金より高くなる場合が"
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "indent" }, [_vm._v("ございます。")]),
              _vm._v(" "),
              _c("li", { staticClass: "indent" }, [
                _vm._v(
                  "その場合は、作業前に協議を行い、双方合意の上で代金額を決定した上で"
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "indent" }, [
                _vm._v("組立設置作業を行います。")
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "・ご注文後のキャンセルは、お受けいたしかねますので、予めご了承ください。"
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "indent" }, [
                _vm._v("(返金いたしかねますので、ご了承ください)")
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "・床・壁・天井への固定が必要な設置の場合には、床・壁・天井に穴を空けること"
                )
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "indent" }, [
                _vm._v("について予めご承諾いただいたものとします。")
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "・当社の組立・設置が終了した後、お客様は完了確認をお願いします。"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "・当社は、お客様起因による家具組立前の破損等について一切の責任を負いません。"
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("・組立・設置後の代金の返金請求は一切お受けできません。")
              ]),
              _vm._v(" "),
              _c("li", [_vm._v("・不要な家具の引き取りは行っておりません。")])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e885ece", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e885ece","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/components/common/DcStructRuleDetial.vue
// module id = null
// module chunks = 